export default "__VITE_ASSET__BeNUoZp1__"